const docRoute = (slug: string) => `/documentation/${slug}` as const;

export const route = {
    patterns: {
        aiImpactOnJobs: docRoute('ai-impact-on-jobs'),
        aiSystemsHrDeepDive: docRoute('ai-systems-hr-deepdive'),
        article4GenderNeutralPay: docRoute('article-4-gender-neutral-pay'),
        article6EqualWork: docRoute('article-6-equal-work'),
        bestPracticesLeveling: docRoute('best-practices-leveling'),
        chatbotsVsAgents: docRoute('chatbots-vs-agents'),
        connectCobrainerMcpToMicrosoft365Copilot: docRoute('connect-cobrainer-mcp-to-microsoft-365-copilot'),
        documentation: '/documentation',
        euPayTransparencyDirective: docRoute('eu-pay-transparency-directive'),
        glossary: docRoute('glossary'),
        gradingFrameworks: docRoute('grading-frameworks'),
        greatJobRoleDescription: docRoute('great-job-role-description'),
        hrProcessesAgentAutomation: docRoute('hr-processes-agent-automation'),
        humanAiHybridOrganizations: docRoute('human-ai-hybrid-organizations'),
        implementationGuide: docRoute('implementation-guide'),
        internationalPayTransparency: docRoute('international-pay-transparency'),
        introduction: docRoute('introduction'),
        jobFamiliesClustersRolesLevels: docRoute('job-families-clusters-roles-levels'),
        jobRoleTemplates: docRoute('job-role-templates'),
        mcpModelContextProtocol: docRoute('mcp-model-context-protocol'),
        mcpServersHrSpace: docRoute('mcp-servers-hr-space'),
        measurementKpis: docRoute('measurement-kpis'),
        payBandsCareerTracks: docRoute('pay-bands-career-tracks'),
        performanceReviewsSkillsArchitecture: docRoute('performance-reviews-skills-architecture'),
        quickStart: docRoute('quick-start'),
        resourcesTemplatesIntegration: docRoute('resources-templates-integration'),
        riskCategoriesComplianceEqualPay: docRoute('risk-categories-compliance-equal-pay'),
        roiAgentificationHumanAi: docRoute('roi-agentification-human-ai'),
        roiCalculationMethod: docRoute('roi-calculation-method'),
        roiJobSkillArchitecture: docRoute('roi-job-skill-architecture'),
        roiLearningManagement: docRoute('roi-learning-management'),
        roiOverview: docRoute('roi-overview'),
        roiPerformanceDevelopmentCareer: docRoute('roi-performance-development-career'),
        roiRecruitingOnboarding: docRoute('roi-recruiting-onboarding'),
        roiStrategicWorkforcePlanning: docRoute('roi-strategic-workforce-planning'),
        roiSuccessionManagement: docRoute('roi-succession-management'),
        skillFilesCobrainerEcosystem: docRoute('skill-files-cobrainer-ecosystem'),
        skillsCompetencyClustersProficiency: docRoute('skills-competency-clusters-proficiency'),
        skillsDriveTalentProcesses: docRoute('skills-drive-talent-processes'),
        skillsMappingHeadcountCourses: docRoute('skills-mapping-headcount-courses'),
        transitioningSkillsBasedOrg: docRoute('transitioning-skills-based-org'),
        whatIsAToolCall: docRoute('what-is-a-tool-call'),
        whatIsJobArchitecture: docRoute('what-is-job-architecture'),
    },
    searchParams: {
        goBackTo: 'goBackTo',
    },
};
